__turbopack_context__.v({
  "pageEmpty": "PageEmpty-module-scss-module__ZSZEkW__pageEmpty",
});
